module.exports = __webpack_public_path__ + "img/a4.3ceb7ef6.jpg";